import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function EditDialog(props) {
    const { onSave, onClose, selectedValue, open } = props;

    const [vehicleId, setVehicleId] = React.useState("");
    const [vendorId, setVendorId] = React.useState("");
    const [vehicleNo, setVehicleNo] = React.useState("");
    const [vehicleType, setVehicleType] = React.useState("");
    const [locationName, setLocationName] = React.useState("");
    const [locationLat, setLocationLat] = React.useState("");
    const [locationLng, setLocationLng] = React.useState("");
    const [capacity, setCapacity] = React.useState("");

    React.useEffect(() => {
        if (selectedValue) {
            setVehicleId(selectedValue.vehicle_id);
            setVendorId(selectedValue.vendor_id);
            setVehicleNo(selectedValue.vehicle_no);
            setVehicleType(selectedValue.vehicle_type);

            setLocationName(selectedValue.location.name);
            setLocationLat(selectedValue.location.lat);
            setLocationLng(selectedValue.location.lng);
            setCapacity(selectedValue.capacity);
        }
    }, [selectedValue])

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            vehicle_id: vehicleId,
            vendor_id: vendorId,
            vehicle_no: vehicleNo,
            vehicle_type: vehicleType,
            location: {
                name: locationName,
                lat: parseFloat(locationLat),
                lng: parseFloat(locationLng)
            },
            capacity: parseInt(capacity),
            status: selectedValue.status
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Edit vehicle`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <TextField
                    id="vehicle-id"
                    label="Vehicle Id"
                    InputProps={{
                        readOnly: true,
                        disabled: true
                    }}
                    value={vehicleId}
                    onChange={(e) => setVehicleId(e.target.value)}
                />
                <TextField
                    id="vendor-id"
                    label="Vendor Id"
                    InputProps={{
                        readOnly: true,
                        disabled: true
                    }}
                    value={vendorId}
                    onChange={(e) => setVendorId(e.target.value)}
                />
                <TextField
                    id="vehicle-no"
                    label="Vehicle No."
                    value={vehicleNo}
                    onChange={(e) => setVehicleNo(e.target.value)}
                />
                <TextField
                    id="vehicle-type"
                    label="Vehicle Type"
                    value={vehicleType}
                    onChange={(e) => setVehicleType(e.target.value)}
                />
                <TextField
                    id="location-name"
                    label="Location Name"
                    InputProps={{
                        readOnly: true,
                        disabled: true
                    }}
                    value={locationName}
                    onChange={(e) => setLocationName(e.target.value)}
                />
                <TextField
                    id="location-lat"
                    label="Location Latitude"
                    InputProps={{
                        readOnly: true,
                        disabled: true
                    }}
                    value={locationLat}
                    onChange={(e) => setLocationLat(e.target.value)}
                />
                <TextField
                    id="location-lng"
                    label="Location Longitude"
                    InputProps={{
                        readOnly: true,
                        disabled: true
                    }}
                    value={locationLng}
                    onChange={(e) => setLocationLng(e.target.value)}
                />
                <TextField
                    id="capacity"
                    label="Capacity"
                    value={capacity}
                    onChange={(e) => setCapacity(e.target.value)}
                />
                <div style={{ margin: '10px', float: 'right' }}>
                    <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                    <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                </div>
            </Box>
        </Dialog>
    );
}
